import { createRoot } from 'react-dom/client'
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components'
import './styles/tailwind.css'
import App from './App'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <FluentProvider theme={teamsLightTheme}>
    <App />,
  </FluentProvider>
)
